"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactSalesButtonPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var ContactSalesButtonPropsInterface = Object.assign({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
  additionalUnitQuantity: _propTypes.default.number,
  allowModal: _propTypes.default.bool,
  contactIsc: _propTypes.default.bool,
  termId: _propTypes.default.number,
  use: _propTypes.default.string,
  _textOverride: _propTypes.default.node,
  onClick: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  _overrideCommunicationMethodKey: _propTypes.default.string,
  _buttonOverride: _propTypes.default.node,
  _overrideModalHeaderText: _propTypes.default.node
});
exports.ContactSalesButtonPropsInterface = ContactSalesButtonPropsInterface;